import { withPrefix } from "gatsby"


export const withoutPrefix = path => {
    if (!path) {
        return path;
    }

    const prefix = withPrefix(`/`).slice(0, -1);

    if (!prefix || !path.toLowerCase().startsWith(prefix.toLowerCase())) {
        return path;
    }

    const result = path.substring(prefix.length);

    return result;
}